export default __webpack_public_path__ + "static/media/ear-left.32c541b0.svg";